import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { formatCurrencyNumber } from "./utils.js";
import '../progress-bars/common/progress-milestones/progress-milestones.css';function ProgressMilestones(props) {
  const { goalAmount, currentAmount, milestones, minified, showMilestones } = props;
  const [goal, setGoal] = useState(goalAmount);
  useEffect(() => {
    if (!milestones || milestones.length === 0) return;
    const next = milestones.filter(
      (milestone) => Number.parseFloat(milestone.amount.value) > currentAmount
    ).sort(
      (a, b) => Number.parseFloat(a.amount.value) - Number.parseFloat(b.amount.value)
    )[0];
    if (!next) setGoal(goalAmount);
    else setGoal(parseFloat(next.amount.value));
  }, [milestones, goalAmount, currentAmount]);
  const baseClassName = minified ? "progress-bar-milestones-min" : "progress-bar-milestones";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${baseClassName} ${milestones && showMilestones ? "active" : "deactive"}`,
      id: "milestone",
      children: [
        milestones == null ? void 0 : milestones.map((milestone) => /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${baseClassName}__text ${Number.parseFloat(milestone.amount.value) > currentAmount ? "higher" : "lower"}`,
            children: [
              !minified && /* @__PURE__ */ jsx("div", { className: "m_next", children: "Next Milestone:" }),
              /* @__PURE__ */ jsx("div", { className: "m_info", children: /* @__PURE__ */ jsxs("span", { children: [
                "$",
                formatCurrencyNumber(milestone.amount.value),
                " - ",
                milestone.name
              ] }) })
            ]
          },
          milestone.id
        )),
        /* @__PURE__ */ jsx("div", { className: `${baseClassName}__text higher`, children: !minified ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "m_next", children: "Next Milestone:" }),
          /* @__PURE__ */ jsx("div", { className: "m_info", children: /* @__PURE__ */ jsxs("span", { children: [
            "Reach our goal of $",
            goal
          ] }) })
        ] }) : /* @__PURE__ */ jsx("div", { className: "m_info", children: /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsxs("strong", { children: [
            "$",
            goal
          ] }),
          " - Reach our goal!"
        ] }) }) })
      ]
    }
  );
}
export {
  ProgressMilestones
};
//# sourceMappingURL=progress-milestones.js.map
